module.exports = __webpack_public_path__ + "static/media/Ana_PEng_s1.23147c7b.mp3";